import { z } from 'my-zod'

export const outfitterGoogleAnalytics = z.object({
  outfitterId: z.number(),
  measurementId: z.string().max(32),
  secret: z.string().nullable(),
  secretLast4: z.string().max(4).nullable()
})

export type outfitterGoogleAnalytics = z.infer<typeof outfitterGoogleAnalytics>

export const outfitterGoogleAnalyticsWithoutSecret = outfitterGoogleAnalytics.omit({ secret: true })

export type outfitterGoogleAnalyticsWithoutSecret = z.infer<typeof outfitterGoogleAnalyticsWithoutSecret>
